<template>
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-lg-auto"><h4 class="card-title mb-0">Almost there - Provide other's info</h4></div>

            </div>

        </div><!-- end card header -->

        <div class="card-body form-steps">
            <div class="select-step product-select-step">
                <!-- progressbar -->
                <div class="step-arrow-nav mb-4">
                    <ul id="progressbar" class="nav nav-pills custom-nav nav-justified">
                        <li class="active">Step 1</li>
                        <li class="active">Step 2</li>
                        <li class="active">Step 3</li>
                    </ul>
                </div>

                <div class="ppostep4">
                    <div class="">
                        <div class="setp4col">
                            <div class="step4row-height">
                            <div class="table-responsive product-status" v-if="newOrder.products.length">
                                <h4>All Products</h4>
                                <table class="table table-striped table-bordered mb-2">
                                    <thead>
                                    <tr>
                                        <th style="width:160px;">Item #</th>
                                        <th style="width:450px;">Product Name and Description</th>
                                        <th>Quantity
                                        <template v-for="(product, index) in newOrder.products" v-if="index === 0">
                                            /{{getSelectedQuantityUnit(product.qty_unit_id)}}
                                        </template>
                                        </th>
                                        <!-- <th>UOM</th> -->
                                        <th>Cost</th>
                                        <th>Total</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(product, index) in newOrder.products" :id="product.id">
                                        <td>#{{product.product_num}}</td>
                                        <td>
                                            {{product.product_name}}
                                            <div v-html="product.product_desc"></div>
                                        </td>
                                        <td>
                                            {{product.quantity}}
                                        </td>
                                        <!-- <td>{{getSelectedQuantityUnit(product.qty_unit_id)}}</td> -->
                                        <td>
                                            ${{product.price}}
                                        </td>
                                        <td>
                                            ${{product.cost}}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            </div>

                            <ValidationObserver v-slot="{ handleSubmit }">
                                <form @submit.prevent="handleSubmit(saveOrder)">
                                    <div class="row justify-content-center">
                                        <div class="col-sm-8 col-md-8">
                                            <div class="row">
                                                <div class="col-sm-3 col-md-3">
                                                    <div class="form-group">
                                                        <label>PO Number</label>
                                                        <input type="text" class="form-control" placeholder="" name="po_number"
                                                               v-model="newOrder.po_number">
                                                    </div>
                                                </div>
                                                <div class="col-sm-3 col-md-3">
                                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                                        <div class="form-group">
                                                            <label>PO date</label>
                                                            <date-picker v-model="newOrder.order_date" valueType="format" format="MM/DD/YYYY"
                                                                         :input-class="{error: errors.length, 'mx-input': true}"></date-picker>
                                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="col-sm-3 col-md-3">
                                                    <div class="form-group">
                                                        <label>Factory Ready Date</label>
                                                        <date-picker v-model="newOrder.eta" valueType="format" format="MM/DD/YYYY"
                                                                     :input-class="{'mx-input': true}"></date-picker>
                                                    </div>
                                                </div>
                                                <div class="col-sm-3 col-md-3">
                                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                                        <div class="form-group">
                                                            <label>Date need to be delivered</label>
                                                            <date-picker v-model="newOrder.delivery_date" valueType="format" format="MM/DD/YYYY"
                                                                         :input-class="{error: errors.length, 'mx-input': true}"></date-picker>
                                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="col-sm-3 col-md-3">
                                                    <div class="form-group">
                                                        <label>Customer PO</label>
                                                        <input type="text" class="form-control" placeholder="" name="customer_po"
                                                               v-model="newOrder.vendor_po">
                                                    </div>
                                                </div>
                                                <div class="col-sm-3 col-md-3">
                                                    <div class="form-group">
                                                        <label>FOB</label>
                                                        <input type="text" class="form-control" placeholder="" name="fob"
                                                               v-model="newOrder.fob">
                                                    </div>
                                                </div>
                                                <div class="col-sm-3 col-md-3">
                                                    <div class="form-group">
                                                        <label>Vendor Terms</label>
                                                        <input type="text" class="form-control" placeholder=""
                                                               name="customer_terms" v-model="newOrder.vendor_terms">
                                                    </div>
                                                </div>
                                                <div class="col-sm-3 col-md-3">
                                                    <div class="form-group">
                                                        <label>Quote Number</label>
                                                        <input type="text" class="form-control" placeholder=""
                                                               name="customer_terms" v-model="newOrder.quote_num">
                                                    </div>
                                                </div>


                                                <div class="col-sm-12 col-md-12">
                                                    <div class="radiogroups">
                                                        <div class="form-check-inline">Use Sales order notes?</div>
                                                        <div class="form-check-inline">
                                                            <label class="form-check-label">
                                                                <input type="checkbox" class="form-check-input" name="is_use_so_notes" v-model="is_use_so_notes">
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-sm-6 col-md-6">
                                                    <div class="form-group">
                                                        <label>Order Notes</label>
                                                        <!--<textarea rows="2" cols="75" class="form-control"
                                                                v-model="newOrder.vendor_notes"></textarea>-->
                                                        <vue-editor v-model="newOrder.vendor_notes" :editorToolbar="getQuillToolbar()"></vue-editor>

                                                    </div>
                                                </div>

                                                <div class="col-sm-6 col-md-6">
                                                    <div class="form-group">
                                                        <label>Internal Notes</label>
                                                        <!--<textarea rows="2" cols="75" class="form-control"
                                                                v-model="newOrder.notes"></textarea>-->
                                                        <vue-editor v-model="newOrder.notes" :editorToolbar="getQuillToolbar()"></vue-editor>

                                                    </div>
                                                </div>

                                                <div
                                                        class="col-sm-12 col-md-12"
                                                    >
                                                        <template
                                                            v-if="
                                                                charges.length >
                                                                0
                                                            "
                                                        >
                                                            <div
                                                                v-for="(
                                                                    charge,
                                                                    index
                                                                ) in charges"
                                                                :key="
                                                                    'type_' +
                                                                    charge.id +
                                                                    '_' +
                                                                    charge.cost_type +
                                                                    '_' +
                                                                    index
                                                                "
                                                            >
                                                                <div
                                                                    class="quantity-row"
                                                                >
                                                                    <div
                                                                        class="quantity-col1"
                                                                    >
                                                                        <a
                                                                            href="javascript:void(0);"
                                                                            v-on:click="
                                                                                editCharge(
                                                                                    index,
                                                                                    charge
                                                                                )
                                                                            "
                                                                            >{{
                                                                                charge.cost_type
                                                                            }}:</a
                                                                        >
                                                                        <template
                                                                            v-if="
                                                                                charge.quantity !=
                                                                                    null &&
                                                                                charge.quantity >
                                                                                    0
                                                                            "
                                                                        >
                                                                            ${{
                                                                                charge.amount
                                                                            }}
                                                                            x{{
                                                                                charge.quantity
                                                                            }}
                                                                        </template>
                                                                    </div>
                                                                    <span
                                                                        class="cdl"
                                                                        >:</span
                                                                    >
                                                                    <div
                                                                        class="quantity-col2"
                                                                    >
                                                                        ${{
                                                                            charge.quantity !=
                                                                                null &&
                                                                            charge.quantity >
                                                                                0
                                                                                ? charge.amount *
                                                                                  charge.quantity
                                                                                : charge.amount
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <a
                                                            href="javascript:void(0);"
                                                            data-toggle="modal"
                                                            data-target="#extraChargeModal"
                                                            class="btn btn-primary px-3 py-2"
                                                            >Add charge</a
                                                        >

                                                        <!--<template v-else> _</template>-->
                                                    </div>


                                            </div>
                                        </div>
                                    </div>


                                    <div class="btnrow text-right">
                                    <button  type="button" @click="goBack" class="btn btn-light btn-label left-btn previestab w-lg"><i  class="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i> Back</button>
                                        <button type="button" @click="saveAsDraft" :disabled="loading || saveDone == true"
                                                class="btn custom-btn ml-3">Save As Draft
                                        </button>
                                        <button type="submit" ref="submitButton" :disabled="loading || saveDone == true"
                                                class="btn  btn-success right btn-label ml-3">Save <i  class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                        </button>
                                    </div>

                                </form>
                            </ValidationObserver>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <OrderExtraChargeModal
            :order="null"
            :sub_total_cost="null"
            :charge="charge"
            :bus="bus"
            ref="orderExtraCharge"
            @extraChargeAdded="extraChargeAdded"
        ></OrderExtraChargeModal>

    </div>
</template>

<script>

import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import * as moment from 'moment';
import {ValidationProvider, ValidationObserver} from 'vee-validate';
import { VueEditor } from "vue2-editor";
import Vue from "vue";
import OrderExtraChargeModal from "../../components/OrderExtraChargeModal";
export default {
    name: "PurchaseProvideOtherInfo",
    components: {
        DatePicker,
        ValidationProvider,
        ValidationObserver,
        VueEditor,
        OrderExtraChargeModal
    },
    created() {
        if (this.purchaseOrderState) {
            this.newOrder = this.purchaseOrderState.newOrder;

            if (this.newOrder.order_date == null) {
                this.newOrder.order_date = moment().format("MM/DD/YYYY");
            }
        }
    },
    beforeRouteLeave (to, from , next) {
        if(this.saveDone ||  to.name == 'purchaseSelectVendor') {
            next();
        } else {
            const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
            if (answer) {
                next();
            } else {
                next(false);
            }
        }
    },
    data() {
        return {
            bus: new Vue(),
            newOrder: {
                vendor: null,
                order_id: null,
                vendor_id: null,
                is_draft: 0,
                po_number: null,
                order_date: null,
                vendor_terms: null,
                vendor_po: null,
                vendor_fob: null,
                eta: null,
                delivery_date: null,
                notes: null,
                vendor_notes: null,
                po_status_id: 1,
                products: [],
                selectedProducts: [],
                quote_num: null
            },
            charges: [],
            chargeIndex: null,
            charge: null,
            submitted: false,
            saveDone: false,
            salesOrder: null,
            is_use_so_notes: false,
            quantityUnits: []
        }
    },
    mounted() {
        if(this.settings && this.settings.po_setting && this.settings.po_setting.default_po_note) {
            if(this.newOrder.notes == null || this.newOrder.notes == '') {
                this.newOrder.notes = this.settings.po_setting.default_po_note;
            }
        }

        this.getOrderNum(this.newOrder.order_id);

        this.getSalesOrder();
        this.getQuantityUnits();
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setNewPurchaseOrder',
            'setLoading',
            'setOrdersLoading'
        ]),
        extraChargeAdded(event) {
            if (event.chargeIndex != null) {
                this.charges[event.chargeIndex].cost_type =
                    event.chargeData.cost_type;
                this.charges[event.chargeIndex].amount =
                    event.chargeData.amount;
                this.charges[event.chargeIndex].quantity =
                    event.chargeData.quantity;
                //console.log(this.charges[event.chargeIndex])
            } else {
                this.charges.push(_.cloneDeep(event.chargeData));
            }
        },

        goBack() {
            this.$router.push({name: 'purchaseSelectVendor'});
        },
        getOrderNum(order_id) {
            let self = this;
            this.setOrdersLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('po.initOrderNumber', {order_id: order_id}), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        if (data.data) {
                            this.newOrder.po_number = data.data;
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setOrdersLoading(false);

                });
        },
        saveAsDraft() {
            this.$confirm(
                {
                    message: `Do you want to save as Draft?`,
                    button: {
                        no: 'No',
                        yes: 'Yes'
                    },
                    callback: confirm => {
                        if (confirm) {
                            this.newOrder.is_draft = 1;
                            this.$refs.submitButton.click();
                        }
                    }
                }
            )
        },
        saveOrder(e) {
            if (this.saveDone) {
                self.setSuccessMessage('Data already saved!');
                return false;
            }
            let self = this;
            this.submitted = true;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            if (this.charges.length) {
                this.newOrder["charges"] = this.charges;
            }
            
            return axios.post(window.route('purchase-orders.store'), this.newOrder, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                        this.submitted = false;
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        this.submitted = false;
                    } else {
                        self.saveDone = true;
                        self.setSuccessMessage('PO created successfully!');
                        this.setNewPurchaseOrder({
                            vendor: null,
                            order_id: null,
                            vendor_id: null,
                            is_draft: 0,
                            po_number: null,
                            order_date: null,
                            vendor_terms: null,
                            vendor_po: null,
                            vendor_fob: null,
                            eta: null,
                            delivery_date: null,
                            notes: null,
                            po_status_id: 1,
                            products: [],
                            selectedProducts: [],
                            quote_num: null
                        });
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                            self.$router.push({name: 'purchaseOrderShow', params: {id: data.data.id}});
                        }, 10);
                    }
                })
                .catch((error) => {
                    this.submitted = false;
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });

        },
        getSalesOrder() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('orders.show', {id: this.newOrder.order_id}), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.salesOrder = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getSelectedQuantityUnit(qty_unit_id){
            if(qty_unit_id && this.quantityUnits.length) {
                let qty_unit = this.quantityUnits.find((x) => x.id == qty_unit_id);
                if(qty_unit) {
                    return qty_unit.name;
                }
            }
            return null;
        },
        getQuantityUnits() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('so-quantity-units.index'), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.quantityUnits = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getQuillToolbar() {
            return [
                [
                    {
                        'size': []
                    },
                    'bold',
                    {
                        'color': []
                    },
                    {
                        'background': []
                    },
                    {
                        'list': 'ordered'
                    },
                    {
                        'list': 'bullet'
                    }
                ]
            ];
        }
    },
    watch: {
        'is_use_so_notes': {
            handler: function (after, before) {
                if(after == true) {
                    this.newOrder.notes = this.salesOrder.notes;
                    this.newOrder.vendor_notes = this.salesOrder.customer_notes;
                }
            }
        }
    },
    computed: {
        ...mapState([
            'userState',
            'purchaseOrderState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
            'getPurchaseOrderState',
            'settings'
        ])
    }
}
</script>

<style scoped>
.error {
    color: red;
}
</style>
